import utils from '@/utils';
import requester, { IRequesterResponse } from '@/utils/requester';
import dayjs from 'dayjs';
import _ from 'lodash';

export interface IDataUpsertEmr {
  _id?: string;
  uid: string;
  type: string;
  data: any;
  date?: Date;
  source?: {
    name?: string;
    key?: string;
  };
  tags: string[];
}

export interface IParamsGetGroup {
  uid: string;
  start?: string;
  end?: string;
  type?: string;
  group?: string;
  tag?: string;
}

export interface IParamsGetGroupNext extends Omit<IParamsGetGroup, 'end'> {
  addNextDay?: number;
}

export interface IParamsGetEmr {
  _id?: string;
  filter?: string;
  uid?: string;
  start?: Date;
  end?: Date;
  type?: string;
  limit?: number;
  offset?: number;
  page?: number;
}

const emrApi = {
  async upsert({ _id, ...data }: IDataUpsertEmr) {
    let result: IRequesterResponse;

    if (_id) {
      result = await requester.patch('/phr/v1/emrs', {
        _id,
        ...data,
      });
    } else {
      result = await requester.post('/phr/v1/emrs', {
        ...data,
      });
    }
    return result;
  },
  async getGroup(params: IParamsGetGroup) {
    return await requester.get('/phr/v1/emrs/group', { params: _.pickBy(params, _.identity) });
  },
  async getGroupAndNext(params: IParamsGetGroup) {
    const resGroup = await emrApi.getGroup(params);
    const resNext = await emrApi.getGroupNext(params);
    if (resNext.data) {
      resGroup.meta = {};
      resGroup.meta.start = dayjs(resNext.data).add(-10, 'd').toISOString();
      resGroup.meta.end = params.start;
    }

    return resGroup;
  },
  async getGroupNext(params: IParamsGetGroupNext) {
    return await requester.get('/phr/v1/emrs/group/next', { params: _.pickBy(params, _.identity) });
  },
  async getEmr(params: IParamsGetEmr) {
    const { page = 1, limit = 20 } = params || {};
    const offset = params.offset || utils.pagination({ page, limit }).offset;
    if (_.isElement(params) || (!params._id && !params.uid)) {
      console.log('🚀 ~ file: api.ts:81 ~ getEmr ~ params:', params);
      return null as unknown as IRequesterResponse;
    }
    return await requester.get('/phr/v1/emrs', { params: _.pickBy({ ...params, offset }, _.identity) });
  },
  async countHr(uid: string) {
    return await requester.get('/phr/v1/emrs/count', { params: { uid } });
  },
};

export default emrApi;
